export const siteInfo = {
  name: "菲菲影院",
  slogan: "最新热播剧一网打尽，追剧从未如此畅快",
  tag: "每日更新 · 高清不卡顿 · 海量剧集",
  description: "菲菲影院是国内领先的电视剧免费在线观看平台，收录海量国产剧、港剧、韩剧、美剧及热门综艺，每日同步更新最新剧集。平台采用高速CDN加速技术，确保高清画质不缓冲，为追剧爱好者提供流畅舒适的观影体验。无论是最新热播剧全集，还是经典老剧重温，菲菲影院都能满足您连续追剧的需求。",
  stats: [
    { value: "20000+", label: "海量剧集" },
    { value: "每日50+", label: "同步更新" },
    { value: "1080P", label: "高清画质" },
  ],
};

export const carouselItems = [
  {
    id: 1,
    title: "长安十二时辰",
    subtitle: "年度古装悬疑巨制",
    tag: "口碑神作",
    description: "雷佳音、易烊千玺主演，马伯庸同名小说改编。上元节前夕，长安城混入可疑人员，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%2C%20Tang%20Dynasty%20Changan%20city%20night%20scene%20with%20lanterns%20and%20palace%20architecture%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20mysterious%20atmosphere%2C%20dramatic%20composition%2C%20film%20poster%20quality%2C%20Chinese%20historical%20aesthetic&width=600&height=800&seq=carousel-01&orientation=portrait",
  },
  {
    id: 2,
    title: "狂飙",
    subtitle: "年度现象级刑侦大剧",
    tag: "必看神剧",
    description: "张译、张颂文联袂演绎，二十年黑白较量。刑警安欣与黑恶势力高启强横跨二十年的生死交锋，展现扫黑除恶的惊心动魄。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20style%2C%20two%20men%20facing%20each%20other%20in%20dramatic%20lighting%2C%20dark%20urban%20background%2C%20intense%20moody%20atmosphere%2C%20gold%20and%20crimson%20color%20palette%2C%20film%20noir%20aesthetic%2C%20Chinese%20police%20drama%20visual&width=600&height=800&seq=carousel-02&orientation=portrait",
  },
  {
    id: 3,
    title: "三体",
    subtitle: "刘慈欣科幻史诗首部影视化",
    tag: "科幻巨制",
    description: '纳米科学家汪淼与刑警史强共同揭开地外文明「三体」世界的神秘面纱，一场跨越星际的文明博弈就此展开。',
    image: "https://readdy.ai/api/search-image?query=Sci-fi%20Chinese%20drama%20poster%20style%2C%20cosmic%20space%20with%20three%20suns%20and%20alien%20civilization%20elements%2C%20dark%20universe%20background%20with%20stars%2C%20mysterious%20and%20grand%20scale%2C%20cinematic%20lighting%2C%20cold%20metallic%20tones%20with%20deep%20blue%20accents&width=600&height=800&seq=carousel-03&orientation=portrait",
  },
  {
    id: 4,
    title: "繁花",
    subtitle: "王家卫首部电视剧作品",
    tag: "文艺经典",
    description: "胡歌、马伊琍、唐嫣主演，九十年代上海滩商海沉浮。阿宝凭一手股票成为宝总，在黄河路的霓虹灯下书写一代人的激荡岁月。",
    image: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%20style%2C%20neon%20lights%20on%20Nanjing%20Road%20at%20night%2C%20vintage%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20nostalgic%20atmosphere%2C%20Chinese%20business%20drama%20visual%2C%20cinematic%20Wong%20Kar-wai%20style&width=600&height=800&seq=carousel-04&orientation=portrait",
  },
];

export const cardItems = [
  {
    id: 1,
    title: "庆余年 第二季",
    tag: "热播中",
    tagColor: "primary",
    description: "范闲归来，京都风云再起。张若昀携原班人马回归，年度最受期待古装权谋巨制。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20young%20scholar%20in%20ancient%20robe%20holding%20sword%2C%20palace%20background%20with%20warm%20golden%20lighting%2C%20epic%20cinematic%20composition%2C%20rich%20colors%2C%20period%20drama%20aesthetic&width=400&height=560&seq=card-01&orientation=portrait",
    rating: "9.2",
    update: "更新至第28集",
    genre: "古装·权谋",
  },
  {
    id: 2,
    title: "玫瑰的故事",
    tag: "热门",
    tagColor: "accent",
    description: "刘亦菲主演都市情感大剧，一段跨越二十年的女性成长故事，温暖治愈人心。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20modern%20romance%20drama%20poster%2C%20elegant%20woman%20in%20city%20setting%2C%20soft%20warm%20lighting%2C%20rose%20flower%20motif%2C%20emotional%20and%20artistic%20composition%2C%20fashionable%20urban%20aesthetic&width=400&height=560&seq=card-02&orientation=portrait",
    rating: "8.8",
    update: "全集已完结",
    genre: "都市·情感",
  },
  {
    id: 3,
    title: "墨雨云间",
    tag: "新剧",
    tagColor: "primary",
    description: "吴谨言、王星越主演古装复仇爽剧，女主浴火重生步步为营，节奏紧凑酣畅淋漓。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20ancient%20costume%20drama%20poster%2C%20strong%20female%20lead%20in%20red%20hanfu%20dress%2C%20rainy%20ancient%20courtyard%20background%2C%20dramatic%20moody%20lighting%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20cinematic&width=400&height=560&seq=card-03&orientation=portrait",
    rating: "8.5",
    update: "更新至第16集",
    genre: "古装·复仇",
  },
  {
    id: 4,
    title: "我的阿勒泰",
    tag: "口碑",
    tagColor: "secondary",
    description: "马伊琍、周依然主演，改编自李娟同名散文集，新疆阿勒泰壮美风光中的治愈故事。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20featuring%20vast%20grassland%20and%20snow%20mountains%20of%20Xinjiang%20Altay%2C%20nomadic%20life%20aesthetic%2C%20warm%20natural%20lighting%2C%20peaceful%20and%20healing%20atmosphere%2C%20cinematic%20landscape%20composition&width=400&height=560&seq=card-04&orientation=portrait",
    rating: "9.0",
    update: "全集已完结",
    genre: "文艺·治愈",
  },
  {
    id: 5,
    title: "哈尔滨一九四四",
    tag: "谍战",
    tagColor: "primary",
    description: "秦昊、杨幂主演谍战大剧，伪满时期的哈尔滨暗流涌动，双胞胎兄弟的身份迷局扣人心弦。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20drama%20poster%2C%201940s%20Harbin%20winter%20snow%20scene%20with%20Russian%20architecture%2C%20trench%20coat%20figures%20in%20shadow%2C%20cold%20blue%20and%20warm%20amber%20contrast%20lighting%2C%20vintage%20noir%20aesthetic&width=400&height=560&seq=card-05&orientation=portrait",
    rating: "8.3",
    update: "更新至第22集",
    genre: "谍战·悬疑",
  },
  {
    id: 6,
    title: "与凤行",
    tag: "仙侠",
    tagColor: "accent",
    description: "赵丽颖、林更新再度合作，仙魔大战中碧苍王沈璃与神君行止的旷世奇缘，特效炸裂。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%2C%20celestial%20beings%20in%20flowing%20robes%20flying%20among%20clouds%2C%20magical%20glowing%20effects%2C%20ethereal%20golden%20and%20white%20lighting%2C%20dreamy%20atmosphere%2C%20epic%20romantic%20composition&width=400&height=560&seq=card-06&orientation=portrait",
    rating: "8.7",
    update: "全集已完结",
    genre: "仙侠·爱情",
  },
];

export const mediaItems = [
  {
    id: 1,
    title: "《庆余年第二季》范闲朝堂激辩名场面",
    duration: "08:32",
    views: "1280万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20courtroom%20scene%2C%20ancient%20Chinese%20palace%20hall%20with%20officials%2C%20dramatic%20lighting%20with%20golden%20warm%20tones%2C%20cinematic%20wide%20shot%2C%20epic%20atmosphere%2C%20period%20drama%20visual&width=800&height=450&seq=media-01&orientation=landscape",
    tag: "名场面",
    description: "范闲大殿之上慷慨陈词，一句一句揭穿长公主阴谋",
  },
  {
    id: 2,
    title: "《狂飙》高启强最后独白，演技炸裂",
    duration: "12:15",
    views: "2560万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20interrogation%20room%20scene%2C%20single%20man%20under%20harsh%20overhead%20light%2C%20dark%20moody%20atmosphere%2C%20intense%20close-up%20composition%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadows&width=800&height=450&seq=media-02&orientation=landscape",
    tag: "演技炸裂",
    description: "张颂文教科书级表演，二十年反派之路的终极忏悔",
  },
  {
    id: 3,
    title: "《三体》古筝行动震撼视觉呈现",
    duration: "06:48",
    views: "1890万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20scene%2C%20futuristic%20military%20operation%20with%20nanofiber%20technology%2C%20suspenseful%20night%20atmosphere%2C%20cold%20steel%20blue%20tones%2C%20cinematic%20action%20visual%2C%20high-tech%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape",
    tag: "视觉盛宴",
    description: "纳米飞刃切割巨轮，国产科幻剧特效天花板",
  },
  {
    id: 4,
    title: "《我的阿勒泰》草原星空治愈片段",
    duration: "05:20",
    views: "860万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20drama%20night%20scene%20on%20vast%20grassland%20under%20starry%20sky%2C%20campfire%20warm%20glow%2C%20peaceful%20nomadic%20atmosphere%2C%20wide%20landscape%20composition%2C%20healing%20and%20tranquil%20aesthetic&width=800&height=450&seq=media-04&orientation=landscape",
    tag: "治愈时刻",
    description: "阿勒泰的星空下，听见风吹过草原的声音",
  },
];

export const faqItems = [
  {
    id: 1,
    question: "菲菲影院的电视剧真的全部免费吗？",
    answer: "是的，菲菲影院所有电视剧完全免费在线观看，无需会员、无需付费、无需注册。我们通过广告收入维持平台运营，观众只需打开网页即可畅享海量剧集。无论是最新热播剧还是经典老剧，全部免费向所有追剧爱好者开放。",
  },
  {
    id: 2,
    question: "新剧更新速度快吗？能第一时间看到最新剧集吗？",
    answer: "菲菲影院拥有专业的剧集更新团队，与各大平台保持同步更新节奏。国内热播剧通常在播出后2小时内即可上线，部分热门剧集更可实现近乎实时更新。每日更新量超过50集，确保您不会错过任何精彩内容。",
  },
  {
    id: 3,
    question: "播放高清画质需要安装插件或下载播放器吗？",
    answer: "完全不需要。菲菲影院采用先进的HTML5播放技术，支持主流浏览器直接在线播放，无需安装任何插件或播放器。默认提供1080P高清画质，同时根据您的网络状况自动优化码率，确保不缓冲、不卡顿的流畅观看体验。",
  },
  {
    id: 4,
    question: "支持在手机和平板上观看吗？",
    answer: "菲菲影院全面适配手机、平板和电脑等多种设备。在手机上访问菲菲影院，页面会自动适配屏幕尺寸，提供舒适的手持观看体验。您可以在通勤路上、午休时间随时随地追剧，进度还会自动同步。",
  },
  {
    id: 5,
    question: "剧集资源齐全吗？能看美剧和韩剧吗？",
    answer: "菲菲影院收录了极为丰富的剧集资源。除了国产剧全集外，还涵盖热门韩剧、美剧、日剧、泰剧等海外剧集，以及综艺、动漫等品类。平台剧集总数超过20000部，无论是国产古装、都市情感，还是海外悬疑、科幻巨制，都能在这里找到。",
  },
];

export const aboutContent = {
  title: "关于菲菲",
  content: "菲菲影院成立于2018年，是国内领先的免费电视剧在线观看平台。我们致力于为追剧爱好者打造一个资源丰富、体验流畅、完全免费的观影空间。平台收录超过20000部电视剧集，涵盖国产剧、港剧、韩剧、美剧、日剧、泰剧及热门综艺和动漫番剧，每日同步更新50+集最新内容。菲菲影院采用先进的CDN加速与智能码率适配技术，在保障1080P高清画质的同时实现不缓冲的流畅播放。我们坚持\"免费、高清、全量\"的核心理念，让每一位观众都能无门槛享受追剧的乐趣。未来，菲菲影院将持续扩充内容库，优化观看体验，成为您追剧路上的最佳伙伴。",
};

export const rankingItems = [
  { rank: 1, title: "庆余年 第二季", heat: "9.2", trend: "up", tag: "古装权谋" },
  { rank: 2, title: "狂飙", heat: "9.1", trend: "stable", tag: "刑侦涉案" },
  { rank: 3, title: "玫瑰的故事", heat: "8.8", trend: "up", tag: "都市情感" },
  { rank: 4, title: "三体", heat: "8.9", trend: "stable", tag: "科幻巨制" },
  { rank: 5, title: "我的阿勒泰", heat: "9.0", trend: "up", tag: "文艺治愈" },
  { rank: 6, title: "与凤行", heat: "8.7", trend: "down", tag: "仙侠爱情" },
  { rank: 7, title: "墨雨云间", heat: "8.5", trend: "up", tag: "古装复仇" },
];

export const commentItems = [
  {
    id: 1,
    name: "追剧小王子",
    avatar: "https://readdy.ai/api/search-image?query=Default%20user%20avatar%20profile%20picture%2C%20simple%20minimalist%20style%2C%20neutral%20warm%20tone%20background%2C%20generic%20person%20silhouette%2C%20clean%20design&width=80&height=80&seq=avatar-01&orientation=squarish",
    time: "2小时前",
    content: "菲菲影院真的是追剧神器！更新速度比我想象的快多了，《庆余年2》晚上播出第二天早上就能在高清画质下看，而且全程不卡顿，体验太棒了。已经推荐给身边所有追剧的朋友了！",
    likes: 326,
  },
  {
    id: 2,
    name: "深夜追剧人",
    avatar: "https://readdy.ai/api/search-image?query=Default%20female%20user%20avatar%20profile%20picture%2C%20simple%20minimalist%20style%2C%20warm%20tone%20background%2C%20generic%20person%20silhouette%2C%20clean%20design&width=80&height=80&seq=avatar-02&orientation=squarish",
    time: "昨天 23:15",
    content: "作为一个每天通勤两小时的上班族，菲菲影院的手机端体验真的无敌了。在地铁上看《狂飙》高清不缓冲，全集都有，一口气追完太过瘾了。而且分类做得特别清楚，找剧超方便！",
    likes: 198,
  },
  {
    id: 3,
    name: "剧荒终结者",
    avatar: "https://readdy.ai/api/search-image?query=Default%20user%20avatar%20profile%20picture%2C%20simple%20minimalist%20style%2C%20neutral%20background%2C%20generic%20person%20silhouette%2C%20clean%20design&width=80&height=80&seq=avatar-03&orientation=squarish",
    time: "3天前",
    content: "之前一直愁找不到完整剧集资源，自从发现了菲菲影院，剧荒彻底成为历史！海量剧集从国产到海外应有尽有，最惊喜的是连《繁花》这种热门剧全集都能免费看，画质还贼清晰。真心感谢这个平台！",
    likes: 471,
  },
];

export const topicItems = [
  { id: 1, name: "庆余年2大结局", heat: "1280万", color: "primary" },
  { id: 2, name: "狂飙名场面", heat: "2560万", color: "accent" },
  { id: 3, name: "三体古筝行动", heat: "980万", color: "primary" },
  { id: 4, name: "繁花黄河路", heat: "1860万", color: "accent" },
  { id: 5, name: "玫瑰的故事穿搭", heat: "720万", color: "secondary" },
  { id: 6, name: "墨雨云间复仇", heat: "650万", color: "primary" },
  { id: 7, name: "我的阿勒泰同款", heat: "890万", color: "secondary" },
  { id: 8, name: "与凤行特效", heat: "560万", color: "accent" },
  { id: 9, name: "哈尔滨一九四四", heat: "480万", color: "primary" },
  { id: 10, name: "国产剧年度盘点", heat: "2100万", color: "accent" },
];

export const updateItems = [
  { id: 1, time: "刚刚", content: "《庆余年第二季》第29集已更新，范闲身世之谜即将揭晓" },
  { id: 2, time: "1小时前", content: "《玫瑰的故事》全集已上线，刘亦菲演绎二十年女性成长史诗" },
  { id: 3, time: "2小时前", content: "《墨雨云间》第17-18集更新，女主绝地反击高能不断" },
  { id: 4, time: "3小时前", content: "热门韩剧《背着善宰跑》全集更新完毕，奇幻爱情好评如潮" },
  { id: 5, time: "5小时前", content: "《哈尔滨一九四四》第23-24集上线，双胞胎身份危机升级" },
  { id: 6, time: "昨天", content: "经典港剧《大时代》高清修复版上线，重温股市风云传奇" },
  { id: 7, time: "昨天", content: "美剧《龙之家族》第二季同步更新，血龙狂舞震撼来袭" },
  { id: 8, time: "前天", content: "《三体》幕后纪录片独家上线，揭秘古筝行动拍摄全过程" },
  { id: 9, time: "3天前", content: "《琅琊榜》4K修复版全集上线，胡歌经典之作画质全面升级" },
];

export const appContent = {
  title: "菲菲影院 移动端",
  subtitle: "随时随地，追剧不停",
  description: "菲菲影院移动端完美适配手机和平板，支持高清画质、断点续播、离线缓存。无论是在通勤路上、午休时刻还是周末宅家，打开菲菲影院，精彩剧集即刻呈现。",
  features: ["高清画质自适应", "断点续播记忆", "夜间护眼模式", "多设备同步"],
  image: "https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20Chinese%20video%20streaming%20app%20interface%2C%20clean%20modern%20UI%20design%2C%20warm%20red%20and%20gold%20accent%20colors%2C%20drama%20showcase%20screen%2C%20minimalist%20device%20presentation%2C%20elegant%20product%20photography&width=500&height=700&seq=app-01&orientation=portrait",
};

export const indexItems = [
  { id: 1, title: "国产剧专区", count: "8600+部", icon: "ri-tv-line", description: "最新国产热播剧、经典老剧全集" },
  { id: 2, title: "韩剧馆", count: "3200+部", icon: "ri-heart-line", description: "高分韩剧、最新同步跟播" },
  { id: 3, title: "美剧频道", count: "2800+部", icon: "ri-global-line", description: "热门美剧、艾美奖获奖作品" },
  { id: 4, title: "古装剧场", count: "4500+部", icon: "ri-building-line", description: "古装权谋、仙侠爱情、历史传奇" },
  { id: 5, title: "悬疑推理", count: "2100+部", icon: "ri-search-eye-line", description: "烧脑刑侦、谍战悬疑、犯罪心理" },
  { id: 6, title: "都市情感", count: "3500+部", icon: "ri-user-heart-line", description: "都市爱情、家庭伦理、职场励志" },
  { id: 7, title: "综艺娱乐", count: "1800+部", icon: "ri-emotion-laugh-line", description: "热门综艺、搞笑真人秀全集" },
  { id: 8, title: "动漫番剧", count: "5000+部", icon: "ri-ghost-line", description: "日漫国漫、新番追更、经典重温" },
];

export const featureItems = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "极速更新",
    description: "热播剧播出后2小时内上线，每日50+集同步更新，追剧快人一步",
  },
  {
    id: 2,
    icon: "ri-4k-line",
    title: "高清不缓冲",
    description: "1080P高清画质搭配智能CDN加速，网络自适应码率，告别卡顿等待",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "多端适配",
    description: "手机、平板、电脑全端完美兼容，进度云同步，随时随地继续追",
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "安全纯净",
    description: "无弹窗广告骚扰，无恶意插件捆绑，纯净观影环境保障设备安全",
  },
  {
    id: 5,
    icon: "ri-global-line",
    title: "海量资源",
    description: "20000+剧集覆盖国产、韩剧、美剧、日剧，类型齐全满足各种口味",
  },
];

export const contactContent = {
  title: "联系投稿",
  subtitle: "剧集反馈 · 资源建议 · 合作咨询",
  description: "如果您有希望菲菲影院收录的电视剧资源建议，或在使用过程中遇到任何问题，欢迎通过以下方式与我们联系。",
  email: "feedback@feifeicinema.com",
  qq: "官方QQ群：888888888",
  wechat: "微信公众号：菲菲影院",
};

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "热播剧集", href: "#cards" },
  { label: "关于菲菲", href: "#about" },
  { label: "剧集索引", href: "#index" },
  { label: "联系投稿", href: "#contact" },
];